<div class="p-6">
    <h3 class="titre3">{{ 'DIFFUSION.DELETE_CONFIRM_TITLE' | translate }}</h3>
    <p class="mb-6">{{ 'DIFFUSION.DELETE_CONFIRM_TEXT' | translate }}</p>
    <div class="flex justify-end space-x-4">
        <button (click)="annuler()" class="px-4 py-2 btn-secondary-novo">
            {{ 'DIFFUSION.BUTTON_CANCEL' | translate }}
        </button>
        <button (click)="confirmerSuppression()" class="px-4 py-2 btn-primary-novo">
            {{ 'DIFFUSION.BUTTON_CONFIRM' | translate }}
        </button>
    </div>
</div>
